import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class MyReportInboxService {
    
    constructor(private http: HttpClient) { }
	
	//requestPayload = {"sort":[], "filters":[], "filterType":"or"}
	
	/*directoryService(param) {
        return this.http.get('api/v1/directory/'+param+'/directory', { headers: {'X-Auth-Token': localStorage.getItem("token")}, observe: 'response' })
    }*/
	
	recordsService(page,requestPayload) {
		return this.http.post('api/v1/inbox/search?limit=250&page='+page, requestPayload,
		{ headers: {'X-Auth-Token': localStorage.getItem("token")}, observe: 'response' })
	}
	
	historyRecordsService(page,requestPayload) {
		return this.http.post('api/v1/inbox/history/search?limit=250&page='+page, requestPayload,
		{ headers: {'X-Auth-Token': localStorage.getItem("token")}, observe: 'response' })
	}
	
	user() {
		return this.http.post('api/v1/current/user', {}, { headers: {'X-Auth-Token': localStorage.getItem("token")}, observe: 'response' })
    }
	
	/*settingsGetService(){
		return this.http.get('api/v1/user/config', { headers: {'X-Auth-Token': localStorage.getItem("token")}, observe: 'response' })
	}
	
	settingsPostService(settingsReqPayLoad){
		return this.http.put('api/v1/user/config', settingsReqPayLoad, { headers: {'X-Auth-Token': localStorage.getItem("token")}, 
		observe: 'response' })
	}*/
}

